import { createContext, use } from 'react';
import type { FormNameKey } from '../@types/common-data-types';

export interface UserPermissions {
  createRecord: Record<FormNameKey, boolean>;
  editRecord: Record<FormNameKey, boolean>;
  deleteRecord: Record<FormNameKey, boolean>;
  isSuperUser: boolean;
  aiEnabled: boolean;
}

export const UserPermissionsContext = createContext<UserPermissions | undefined>(undefined);

// context consumer hook
export const useUserPermissionsContext = () => {
  const context = use(UserPermissionsContext);

  if (context === undefined) {
    throw new Error('useUserPermissionsContext must be used within a UserPermissionsProvider');
  }

  return context;
};
